module.exports = __webpack_public_path__ + "img/jeweller.dd64cdf.webp";